import React, { useEffect } from "react";
import "./About.css";
import AboutUsImage from "./../../assets/about/About2.webp";
import AboutUsImage2 from "./../../assets/about/About3.webp";
import { useSEO } from "../../context/SEOContext";
import { useTranslation } from "react-i18next";
const About = () => {
  const { t } = useTranslation();
  const setSeo = useSEO();
  useEffect(() => {
    setSeo({
      title: t("about.meta.title"),
      description: t("about.meta.description"),
      keywords: t("about.meta.keywords"),
      favicon: "/faviconnew.png",
      ogUrl: "https://mukemel.com/about",
    });
  }, [setSeo, t]);
  return (
    <>
      <div className="container py-5">
        <div className="row">
          <div className="col-lg-12 mb-5 text-center">
            <h4 className="fw-light">{t("AboutUs")}</h4>
          </div>
        </div>
        <div className="row justify-content-center">
          <div className="col-lg-3 col-6 col-md-4 col-sm-6">
            <img src={AboutUsImage} alt="" className="w-100 rounded-1" />
          </div>
          <div className="col-lg-3 col-6 col-md-4 col-sm-6">
            <img src={AboutUsImage2} alt="" className="w-100 rounded-1" />
          </div>
        </div>
        <div className="row d-flex align-items-center fw-14">
          <div className="col-lg-12">
            <p className="mt-3">{t("Desc1")}</p>
            <h5 className="fw-normal">{t("Whoweare")}</h5>
            <p className="mb-2">{t("Founders")}</p>
            <p className="pt-0">{t("IntroText")}</p>
            <div className="row">
              <div className="col-lg-6">
                <h5 className="fw-normal">{t("MissionTitle")}</h5>
                <p>{t("Mission")}</p>

                <h5 className="fw-normal">{t("VisionTitle")}</h5>
                <p>{t("Vision")}</p>
              </div>
              <div className="col-lg-6">
                <h5 className="fw-normal">{t("ColorSchemeTitle")}</h5>
                <p>{t("ColorScheme")}</p>
                <div className="d-flex flex-column gap-3">
                  <div className="row">
                    <div className="col-lg-6 mb-3">
                      <div className="d-flex align-items-center">
                        <div className="color-box cherry-black me-3 flex-shrink-0"></div>
                        <p className="mb-0">{t("Color_1")}</p>
                      </div>
                    </div>
                    <div className="col-lg-6 mb-3">
                      <div className="d-flex align-items-center">
                        <div className="color-box natural-linen me-3 flex-shrink-0"></div>
                        <p className="mb-0">{t("Color_2")}</p>
                      </div>
                    </div>
                    <div className="col-lg-6 mb-3">
                      <div className="d-flex align-items-center">
                        <div className="color-box madder-red me-3 flex-shrink-0"></div>
                        <p className="mb-0">{t("Color_3")}</p>
                      </div>
                    </div>
                    <div className="col-lg-6 mb-3">
                      <div className="d-flex align-items-center">
                        <div className="color-box madder-red2 me-3 flex-shrink-0"></div>
                        <p className="mb-0">{t("Color_3")}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-12">
                <p className="mt-2">{t("Closing")}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container mb-5">
        <div className="row justify-content-center">
          <div className="col-lg-12">
            <div className="ratio ratio-16x9">
              <iframe
                src="https://www.youtube.com/embed/vEk06tE47dE"
                title="YouTube video player"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowfullscreen
                loading="lazy"
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default About;
